import type { ReduxStateType } from 'Core/store.ts';

const showSelector = (state: ReduxStateType) => state.show;

export const infiniteScrollLoadingSelector = (state: ReduxStateType) =>
  showSelector(state).infiniteScrollLoading;
export const facetsLoadingSelector = (state: ReduxStateType) => showSelector(state).facetsLoading;
export const resultsLoadingSelector = (state: ReduxStateType) => showSelector(state).resultsLoading;
export const viewSelector = (state: ReduxStateType) => showSelector(state).view;
